


































































































import BillingPrice from '@/datatypes/billing/price';
import BillingPriceService from '@/services/billing/BillingPriceService';
import BillingPriceStructure from '@/components/billing/billing-price-structure.vue';
import Vue from 'vue';
import camelcase from 'camelcase';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    billingPrice: new BillingPrice({}),
    billingPriceService: new BillingPriceService(),
    nextPointer: undefined as undefined | string,
    billingSchemes: {
      perUnit: 'Unit',
      tiered: 'Tier (unsupported)',
    },
    isConfirmingInactivate: false,
    isConfirmingReactivate: false,
  }),

  components: {
    BillingPriceStructure,
  },

  mounted() {
    this.getBillingPrice();
  },

  watch: {
    $route() {
      this.getBillingPrice();
    },
  },

  methods: {
    getBillingPrice(): void {
      const billingPriceId = this.$route.params.id;

      this.billingPriceService.show(billingPriceId).then((response) => {
        this.billingPrice = new BillingPrice(camelcaseKeysDeep(response.data));
      });
    },

    deactivatePrice() {
      this.billingPriceService.deactivate(this.billingPrice.id).then((response) => {
        this.isConfirmingInactivate = false;

        this.billingPrice = new BillingPrice(camelcaseKeysDeep(response.data));
        this.$snackbar.message('Price deactivated.');
      });
    },

    reactivatePrice() {
      this.billingPriceService.activate(this.billingPrice.id).then((response) => {
        this.isConfirmingReactivate = false;

        this.billingPrice = new BillingPrice(camelcaseKeysDeep(response.data));
        this.$snackbar.message('Price reactivated.');
      });
    },

    priceUrl(billingPriceId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].price(billingPriceId);
    },
  },

  computed: {
    billingSchemeName(): string {
      if (!this.billingPrice.id) return '';

      return this.billingSchemes[camelcase(this.billingPrice.billingScheme)];
    },
  },
});
